"use client";
// @ts-strict-ignore
import { css } from "styled-components";

// Media Queries
// Mobile-first responsive design

type TagTemplateFunction = (
  templateStrings: TemplateStringsArray,
  ...expr: unknown[]
) => string;
interface ScreenSizes {
  mobile: TagTemplateFunction;
  mobileLandscape: TagTemplateFunction;
  tablet: TagTemplateFunction;
  desktop: TagTemplateFunction;
  midSizeDesktop: TagTemplateFunction;
  largeDesktop: TagTemplateFunction;
  wrap: TagTemplateFunction;
  giantDesktop: TagTemplateFunction;
  lgDesktop: TagTemplateFunction;
  hugeDesktop: TagTemplateFunction;
  xlDesktop: TagTemplateFunction;
}

export const sizes = {
  mobile: 480,
  mobileLandscape: 650,
  tablet: 768,
  desktop: 1024,
  midSizeDesktop: 1140,
  largeDesktop: 1280,
  wrap: 1365,
  giantDesktop: 1600,
  lgDesktop: 1801,
  hugeDesktop: 1920,
  xlDesktop: 2000
};

export const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css(...args)}
    }
  `;

  return acc;
}, {}) as ScreenSizes;

export const mediaDown = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(...args)}
    }
  `;

  return acc;
}, {}) as ScreenSizes;
